import { render, staticRenderFns } from "./addsend.vue?vue&type=template&id=2489d2be"
import script from "./addsend.vue?vue&type=script&lang=js"
export * from "./addsend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports